import Header from '@/components/feature/Header';
import Breadcrumb from '@/components/feature/Breadcrumb';
import Footer from '@/components/feature/Footer';
import FloatingWhatsApp from '@/components/feature/FloatingWhatsApp';
import { CONTACT } from '@/mocks/contactInfo';
import { useDocumentHead } from '@/hooks/useDocumentHead';

export default function MentionsLegales() {
  useDocumentHead({
    title: 'Mentions légales — Gwada Nuisibles',
    description: 'Mentions légales du site Gwada Nuisibles : éditeur, hébergement, propriété intellectuelle, données personnelles et cookies.',
    noindex: true,
  });

  return (
    <main>
      <Header />
      <Breadcrumb items={[{label:'Accueil',href:'/'},{label:'Mentions légales'}]} />

      {/* HERO */}
      <section className="bg-primary-500 py-14 md:py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h1 className="font-heading font-black text-3xl md:text-4xl text-white">
            Mentions légales
          </h1>
        </div>
      </section>

      {/* CONTENU */}
      <section className="bg-white py-14 md:py-20">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed space-y-10">

            {/* Éditeur */}
            <div>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-4">1. Éditeur du site</h2>
              <p>
                Le site <strong>nuisibles-guadeloupe.fr</strong> est édité par <strong>DF PRO</strong>, SASU (société par actions simplifiée unipersonnelle) au capital de 1&nbsp;000&nbsp;€, immatriculée au RCS de Nîmes sous le numéro <strong>984&nbsp;775&nbsp;262</strong> (SIRET du siège&nbsp;: 984&nbsp;775&nbsp;262&nbsp;00020). Numéro de TVA intracommunautaire&nbsp;: FR96&nbsp;984&nbsp;775&nbsp;262.
              </p>
              <p className="mt-2">
                Directeur de la publication : le représentant légal de <strong>DF&nbsp;PRO</strong>.
              </p>
              <p className="mt-2">
                Contact : <strong>{CONTACT.phone}</strong>.
              </p>
              <p className="mt-2">
                Activité : lutte contre les nuisibles (dératisation, désinsectisation, traitement termites) à domicile en Guadeloupe.
              </p>
            </div>

            {/* Hébergement */}
            <div>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-4">2. Hébergement</h2>
              <p>
                Le site est hébergé par l'hébergeur retenu pour la mise en ligne ; ses coordonnées complètes (raison sociale, adresse, téléphone) sont disponibles sur demande.
              </p>
              <p className="mt-2 text-foreground-500 text-sm">
              </p>
            </div>

            {/* Propriété intellectuelle */}
            <div>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-4">3. Propriété intellectuelle</h2>
              <p>
                L&rsquo;ensemble des éléments constituant ce site (textes, images, logos, marques, éléments graphiques) est protégé par les lois relatives à la propriété intellectuelle. Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans l&rsquo;autorisation écrite préalable de l&rsquo;éditeur.
              </p>
              <p className="mt-2">
                Toute exploitation non autorisée du site ou de l&rsquo;un quelconque des éléments qu&rsquo;il contient sera considérée comme constitutive d&rsquo;une contrefaçon et poursuivie conformément aux articles L.335-2 et suivants du Code de la Propriété Intellectuelle.
              </p>
            </div>

            {/* Données personnelles */}
            <div>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-4">4. Données personnelles</h2>
              <p>
                Les informations recueillies via le formulaire de soumission du site sont destinées exclusivement à répondre à votre demande de devis. Elles ne sont jamais revendues, cédées ou utilisées à des fins de prospection commerciale non sollicitée.
              </p>
              <p className="mt-2">
                Conformément à la loi Informatique et Libertés du 6 janvier 1978 modifiée et au Règlement Général sur la Protection des Données (RGPD), vous disposez d&rsquo;un droit d&rsquo;accès, de rectification, d&rsquo;opposition et de suppression des données vous concernant. Pour exercer ce droit, contactez-nous à l&rsquo;adresse indiquée à la section « Éditeur » ou par téléphone au {CONTACT.phone}.
              </p>
              <p className="mt-2">
                Pour toute demande relative à vos données, contactez-nous par téléphone ou via le formulaire du site.
              </p>
            </div>

            {/* Cookies */}
            <div>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-4">5. Cookies</h2>
              <p>
                Ce site n&rsquo;utilise pas de cookies de traçage publicitaire. Les seuls cookies éventuellement déposés sont des cookies techniques strictement nécessaires au fonctionnement du site. Aucun cookie n&rsquo;est déposé à des fins de mesure d&rsquo;audience ou de publicité sans votre consentement explicite.
              </p>
              <p className="mt-2">
                Le site ne dépose aucun cookie publicitaire ni de mesure d’audience.
              </p>
            </div>

            {/* Crédits */}
            <div>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-4">6. Crédits</h2>
              <p>
                Conception et réalisation : Readdy.
              </p>
              <p className="mt-2">
                Images : générées par intelligence artificielle (Stable Diffusion) — aucune personne réelle n&rsquo;est représentée.
              </p>
              <p className="mt-2">
                Polices : Archivo, Inter — sous licence SIL Open Font License.
              </p>
              <p className="mt-2">
                Icônes : Remix Icon — sous licence Apache 2.0.
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
      <FloatingWhatsApp />
    </main>
  );
}